import React, { FunctionComponent } from 'react';
import styles from '../../../../styles/HeadingBlock.module.scss';
import { Headings } from '../../../../services/content/articleBody/enums/Headings';

type Props = {
    content: string;
};

const getHeadingType = (content: string): Headings => {
    let headingType: Headings = content.includes('h1') ? Headings.H1 : Headings.NONE;
    headingType = content.includes('h2') ? Headings.H2 : headingType;
    headingType = content.includes('h3') ? Headings.H3 : headingType;

    return headingType;
};

const removeWrapper = (content: string) => {
    return content.replace(/(<\/?h[1-5]>)/g, '');
};

export const Heading: FunctionComponent<Props> = ({ content }) => {
    const contentHeadingType = getHeadingType(content);
    content = removeWrapper(content);

    switch (contentHeadingType) {
        case Headings.H1: {
            return (
                <h1 key={content} className={`${styles.heading1}`} dangerouslySetInnerHTML={{ __html: content }}></h1>
            );
        }
        case Headings.H2: {
            return (
                <h2 key={content} className={`${styles.heading2}`} dangerouslySetInnerHTML={{ __html: content }}></h2>
            );
        }
        case Headings.H3: {
            return (
                <h3 key={content} className={`${styles.heading3}`} dangerouslySetInnerHTML={{ __html: content }}></h3>
            );
        }
        default: {
            return <h1 key={content} dangerouslySetInnerHTML={{ __html: content }}></h1>;
        }
    }
};
